import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
Vue.use(Router);

import global_ from "../api/global";
import axios from "axios";
Vue.use(global_);

import Head from "@@/pub/header/header";
import Foot from "@@/pub/footer/footer";

export function createRouter() {
  return new Router({
    mode: "history",
    routes: [
      {
        title: "error",
        path: "/error",
        name: "error",
        component: () => import("@@/error/error")
      },
      {
        title: "addSitemap",
        path: "/addSitemap",
        name: "addSitemap",
        component: () => import("@@/addSitemap/addSitemap")
      },
      {
        title: "setEs",
        path: "/setEs",
        name: "setEs",
        component: () => import("@@/setEs/setEs")
      },
      {
        title: "ws",
        path: "/ws",
        name: "ws",
        component: () => import("@@/ws/ws")
      },
      {
        title: "密码登录",
        path: "/passlogin",
        name: "passlogin",
        component: () => import("@@/newlogin/passlogin")
      },
      {
        title: "密码登录",
        path: "/setPassword",
        name: "setPassword",
        component: () => import("@@/newlogin/setPassword")
      },
      // {
      //   title: "注册",
      //   path: "/register",
      //   name: "register",
      //   component: () => import("@@/newlogin/register")
      // },
      {
        title: "QQ绑定账号",
        path: "/login/qq/auth/info",
        name: "/login/qq/auth/info",
        component: () => import("@@/newlogin/binding")
      },
      {
        title: "微信绑定账号",
        path: "/login/weixin/auth/info",
        name: "/login/weixin/auth/info",
        component: () => import("@@/newlogin/binding")
      },
      {
        title: "微信绑定账号",
        path: "/login/weibo/auth/info",
        name: "/login/weibo/auth/info",
        component: () => import("@@/newlogin/binding")
      },
      {
        title: "登录中",
        path: "/auth/authWeiXin",
        name: "/auth/authWeiXin",
        components: {
          default: () => import("@@/waiting/authWeiXin"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "登录中",
        path: "/auth/authQQ",
        name: "/auth/authQQ",
        components: {
          default: () => import("@@/waiting/authQQ"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "登录中",
        path: "/auth/autoLoginQQ",
        name: "/auth/autoLoginQQ",
        components: {
          default: () => import("@@/waiting/autoLoginQQ"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "登录中",
        path: "/auth/authWeiBo",
        name: "/auth/authWeiBo",
        components: {
          default: () => import("@@/waiting/authWeiBo"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "登录中",
        path: "/auth/autoLogin",
        name: "/auth/autoLogin",
        components: {
          default: () => import("@@/waiting/waiting"),
          header: Head,
          footer: Foot
        }
      },
      // {
      //   title: '登录',
      //   path: '/login',
      //   component: () => import('@@/login/login')
      // },
      {
        title: "验证码登录",
        path: "/login",
        name: "login",
        component: () => import("@@/newlogin/codelogin")
      },
      {
        title: "设置昵称",
        path: "/setname",
        name: "setname",
        components: {
          default: () => import("@@/login/setname"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "注册",
        path: "/register",
        name: "register",
        component: () => import("@@/register/register")
      },
      {
        title: "选择感兴趣的类型",
        path: "/selecttype",
        name: "selecttype",
        components: {
          default: () => import("@@/selecttype/selecttype"),
          header: Head,
          footer: Foot
        }
      },
      {
        path: "/about",
        name: "/about",
        components: {
          default: () => import("@@/about/about"),
          header: Head,
          footer: Foot
        }
      },
      {
        path: "/coop",
        name: "/coop",
        components: {
          default: () => import("@@/coop/coop"),
          header: Head,
          footer: Foot
        }
      },
      {
        path: "/",
        name: "index",
        components: {
          default: () => import('@@/news/nIndex/nIndex'),
          header: Head,
          footer: Foot
        }
      },
      {
        path: "/idea",
        name: "idea",
        components: {
          default: () => import('@@/idea/idea'),
          header: Head,
          footer: Foot
        }
      },

      // // 改版新首页
      // {
      //   path: '/',
      //   name: "index",
      //   redirect: "/index",
      //   components: {
      //     default: () => import('@@/news/nIndex/nIndex'),
      //     header: Head,
      //     footer: Foot
      //   }
      // },
      // {
      //   path: '/index',
      //   name: "nindex",
      //   components: {
      //     default: () => import('@@/news/nIndex/nIndex'),
      //     header: Head,
      //     footer: Foot
      //   }
      // },

      {
        title: "活动",
        path: "/activities",
        redirect: "/activities/collect",
        components: {
          default: () => import("@@/activities/activities"),
          header: Head,
          footer: Foot
        },
        children: [
          {
            title: "作品征集",
            path: "collect",
            name: "/activities/collect",
            // component: () => import("@@/activities/collect/collect")
            components: {
              default: () => import("@@/activities/collect/collect"),
              header: Head,
              footer: Foot
            }
          },
          {
            title: "作品征集详情",
            path: "collect/detail",
            name: "/activities/collect/detail",
            component: () => import("@@/activities/collectdetail/collectdetail")
          },
          {
            title: "大赛",
            path: "matchs",
            name: "/activities/matchs",
            // component: () => import("@@/activities/matchs/matchs")
            components: {
              default: () => import("@@/activities/matchs/matchs"),
              header: Head,
              footer: Foot
            }
          },
          {
            title: "大赛详情",
            path: "matchs/detail",
            name: "/matchs/detail",
            component: () => import("@@/activities/matchsdetail/matchsdetail")
          },
          {
            title: "报名",
            path: "enroll",
            name: "enroll",
            component: () => import("@@/activities/enroll/enroll")
          }
        ]
      },
      {
        title: '支付',
        path: '/actcoursepay',
        name: '/actcoursepay',
        components: {
          default: () => import('@@/activities/pay/pay'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "作品",
        path: "/works",
        name: "works",
        components: {
          default: () => import("@@/works/works.vue"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "作品详情页",
        path: "/worksdetail",
        name: "worksdetail",
        components: {
          default: () => import("@@/worksdetail/worksdetail"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "作品详情页-改编剧本",
        path: "/workstory",
        name: "workstory",
        components: {
          default: () => import("@@/worksdetail/workstory"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "作品预览页",
        path: "/worksview",
        name: "worksview",
        components: {
          default: () => import("@@/worksdetail/worksview"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "作品预览页",
        path: "/workstoryview",
        name: "workstoryview",
        components: {
          default: () => import("@@/worksdetail/workstoryview"),
          header: Head,
          footer: Foot
        }
      },

      // {
      //   title: "故事汇",
      //   path: "/storylist",
      //   name: "storylist",
      //   components: {
      //     default: () => import("@@/story/storylist"),
      //     header: Head,
      //     footer: Foot
      //   }
      // },

      {
        title: "故事汇",
        path: "/storypart",
        name: "storypart",
        components: {
          default: () => import("@@/story/story"),
          header: Head,
          footer: Foot
        }
      },

      {
        title: "专栏",
        path: "/columnall",
        name: "columnall",
        components: {
          default: () => import("@@/column/column"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "大V专栏详情",
        path: "/column/davart",
        name: "/column/davart",
        components: {
          default: () => import("@@/column/dav/dav"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "大V详情页",
        path: "/column/davdetail",
        name: "/column/davdetail",
        components: {
          default: () => import("@@/column/davdetail/davdetail"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "专题专栏详情",
        path: "/column/themeart",
        name: "/column/themeart",
        components: {
          default: () => import("@@/column/theme/theme"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "专题详情页",
        path: "/column/themedetail",
        name: "/column/themedetail",
        components: {
          default: () => import("@@/column/themedetail/themedetail"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "文章预览页",
        path: "/column/themeview",
        name: "/column/themeview",
        components: {
          default: () => import("@@/column/themedetail/themeview"),
          header: Head,
          footer: Foot
        }
      },

      {
        path: "/postarticlepost/postarticle-v1",
        name: "postarticle-v1",
        component: () => import("@@/newposter/article-v1/article-v1"),
        meta: {
          title: "文章海报"
        }
      },
      {
        path: "/postproductionpost/postproduction-v1",
        name: "postproduction-v1",
        component: () => import("@@/newposter/production-v1/production-v1"),
        meta: {
          title: "作品海报"
        }
      },
      {
        path: "/postadvertpost/postadvert-v1",
        name: "postadvert-v1",
        component: () => import("@@/newposter/advert-v1/advert-v1"),
        meta: {
          title: "广告海报"
        }
      },
      {
        path: "/postactivitypost/postactivity-v1",
        name: "postactivity-v1",
        component: () => import("@@/newposter/activity-v1/activity-v1"),
        meta: {
          title: "活动海报"
        }
      },
      {
        path: "/postprojectpost/postproject-v1",
        name: "postproject-v1",
        component: () => import("@@/newposter/project-v1/project-v1"),
        meta: {
          title: "活动海报"
        }
      },
      {
        path: '/postmodelpost/postmodel-v1',
        name: '/postmodel-v1',
        component: () => import('@@/newposter/model-v1/model-v1'),
        meta: {
          title: '素材海报'
        },
      },
      {
        path: '/post/wenda',
        name: '/wenda',
        component: () => import('@@/newposter/wenda/wenda'),
        meta: {
          title: '问答海报'
        },
      },
      {
        path: '/post/wenda/ans',
        name: '/wenda/ans',
        component: () => import('@@/newposter/wenda/ans'),
        meta: {
          title: '回答海报'
        },
      },
      {
        path: "/setting",
        name: "/setting",
        components: {
          default: () => import("@@/setting/setting"),
          header: Head,
          footer: Foot
        },
        meta: {
          title: "设置"
        }
      },
      {
        path: "/chatroom",
        name: "/chatroom",
        components: {
          default: () => import("@@/chatroom/chatroom"),
          header: Head,
          footer: Foot
        },
        meta: {
          title: "聊天室"
        }
      },
      {
        path: "/poster",
        name: "/poster",
        component: () => import("@@/poster/poster"),
        meta: {
          title: "生成海报-薇米云"
        }
      },
      // 素材栏目
      {
        title: '素材',
        path: '/source',
        name: 'source',
        components: {
          default: () => import('@@/source/source'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '模型',
        path: '/model',
        name: 'model',
        components: {
          default: () => import('@@/model/list/list'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '模型详情',
        path: '/modeldetail',
        name: 'modeldetail',
        components: {
          default: () => import('@@/model/detail/detail'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "模型预览页",
        path: "/modelview",
        name: "modelview",
        components: {
          default: () => import("@@/model/detail/view"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '动作',
        path: '/action',
        name: 'action',
        components: {
          default: () => import('@@/source/action/list/list'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '动作详情',
        path: '/action/detail',
        name: 'action/detail',
        components: {
          default: () => import('@@/source/action/detail/detail'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "动作预览页",
        path: "/action/view",
        name: "action/view",
        components: {
          default: () => import("@@/source/action/detail/view"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '音效',
        path: '/audio',
        name: 'audio',
        components: {
          default: () => import('@@/source/audio/list/list'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '音效详情',
        path: '/audio/detail',
        name: 'audiodetail',
        components: {
          default: () => import('@@/source/audio/detail/detail'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: "音效预览页",
        path: "/audio/view",
        name: "audio/view",
        components: {
          default: () => import("@@/source/audio/detail/view"),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '支付',
        path: '/pay',
        name: '/pay',
        components: {
          default: () => import('@@/model/pay/pay'),
          header: Head,
          footer: Foot
        }
      },

      {
        title: "个人主页",
        path: "/home",
        name: "home",
        redirect: "/home/dongtai",
        components: {
          default: () => import("@@/home/home"),
          header: Head,
          footer: Foot
        },
        children: [
          {
            title: "个人主页-动态",
            path: "/home/dongtai",
            name: "/home/dongtai",
            component: () => import("@@/home/dongtai/dongtai")
          },
          {
            title: "个人主页-活动",
            path: "/home/huodong",
            name: "/home/huodong",
            component: () => import("@@/home/huodong/huodong")
          },
          {
            title: "个人主页-作品",
            path: "/home/zuopin",
            name: "/home/zuopin",
            component: () => import("@@/home/zuopin/zuopin")
          },
          {
            title: "个人主页-文章",
            path: "/home/wenzhang",
            name: "/home/wenzhang",
            component: () => import("@@/home/wenzhang/wenzhang")
          },
          {
            title: "个人主页-收藏",
            path: "/home/shoucang",
            name: "/home/shoucang",
            component: () => import("@@/home/shoucang/shoucang")
          },
          {
            title: "个人主页-粉丝",
            path: "/home/fensi",
            name: "/home/fensi",
            component: () => import("@@/home/fensi/fensi")
          },
          {
            title: "个人主页-关注",
            path: "/home/guanzhu",
            name: "/home/guanzhu",
            component: () => import("@@/home/guanzhu/guanzhu")
          },
          {
            title: "个人主页-我的标签",
            path: "/home/biaoqian",
            name: "/home/biaoqian",
            component: () => import("@@/home/biaoqian/biaoqian")
          },
          {
            title: "个人主页-好友评价",
            path: "/home/pingjia",
            component: () => import("@@/home/pingjia/pingjia")
          },
          {
            title: "个人主页-好友印象",
            path: "/home/yinxiang",
            name: "/home/yinxiang",
            component: () => import("@@/home/yinxiang/yinxiang")
          },
          {
            title: "个人主页-个人资料",
            path: "/home/ziliao",
            name: "/home/ziliao",
            component: () => import("@@/home/ziliao/ziliao")
          },
          {
            title: "个人主页-好友",
            path: "/home/haoyou",
            name: "/home/haoyou",
            component: () => import("@@/home/haoyou/haoyou")
          },
          {
            title: '个人主页-影响力明细',
            path: '/home/rankdetail',
            name: '/home/rankdetail',
            component: () => import('@@/home/ranking/detail')
          },
          {
            title: '个人主页-访客',
            path: '/home/fangke',
            name: '/home/fangke',
            component: () => import('@@/home/fangke/fangke'),
          },
          {
            title: '个人主页-问答',
            path: '/home/wenda',
            name: '/home/wenda',
            component: () => import('@@/home/wenda/wenda'),
          },
          {
            title: '个人主页-问答详情',
            path: '/home/wenda/detail',
            name: '/home/wenda/detail',
            component: () => import('@@/home/wenda/detail'),
          },
        ]
      },


      {
        title: '课程',
        path: '/course',
        name: 'course',
        components: {
          default: () => import('@@/course/list/list'),
          header: Head,
          footer: Foot
        }
      },

      {
        title: '直播详情',
        path: '/livedetail',
        name: 'livedetail',
        components: {
          default: () => import('@@/course/detail/livedetail'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '点播详情',
        path: '/videodetail',
        name: 'videodetail',
        components: {
          default: () => import('@@/course/detail/videodetail'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '点播详情',
        path: '/videoduo',
        name: 'videoduo',
        components: {
          default: () => import('@@/course/detail/videoduo'),
          header: Head,
          footer: Foot
        }
      },

      {
        title: '支付',
        path: '/coursepay',
        name: '/coursepay',
        components: {
          default: () => import('@@/course/pay/pay'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '点播观看页',
        path: '/videoshow',
        name: 'videoshow',
        components: {
          default: () => import('@@/course/detail/videoshow'),
          header: Head,
          footer: Foot
        }
      },
      {
        path: '/postvideopost/postvideo-v1',
        name: 'postvideo-v1',
        component: () => import('@@/newposter/course-v1/course-v1'),
        meta: {
          title: '点播海报'
        },
      },
      {
        path: '/postlivepost/postlive-v1',
        name: 'postlive-v1',
        component: () => import('@@/newposter/live-v1/live-v1'),
        meta: {
          title: '直播海报'
        },
      },

      //demo
/*
      {
        path: "/home",
        name: "home",
        component: Home
      },
*/

      {
        path: "/detail/:id",
        name: "detail",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "detail" */ "../views/Detail.vue")
      },
      {
        title: '项目大厅',
        path: '/project',
        name: '/project',
        components: {
          default: () => import('@@/project/project/project'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '项目详情',
        path: '/pro/detail',
        name: '/pro/detail',
        components: {
          default: () => import('@@/project/prodetail/prodetail'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '影响力',
        path: '/ranking',
        name: '/ranking',
        components: {
          default: () => import('@@/home/ranking/ranking'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '招募合伙人',
        path: '/recruit',
        name: '/recruit',
        components: {
          default: () => import('@@/recruit/recruit'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '发问答',
        path: '/askque',
        name: '/askque',
        components: {
          default: () => import('@@/question/askque/askque'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '问题支付',
        path: '/questionpay',
        name: '/questionpay',
        components: {
          default: () => import('@@/question/pay/pay'),
          header: Head,
          footer: Foot
        }
      },

      {
        title: '普通问答',
        path: '/gquestions',
        name: '/gquestions',
        components: {
          default: () => import('@@/question/putong'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '普通问答-详情页',
        path: '/gquestionsdetail',
        name: '/gquestionsdetail',
        components: {
          default: () => import('@@/question/detail/ptdetail'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '悬赏问答',
        path: '/rquestions',
        name: '/rquestions',
        components: {
          default: () => import('@@/question/xuanshang'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '悬赏问答-详情页',
        path: '/rquestionsdetail',
        name: '/rquestionsdetail',
        components: {
          default: () => import('@@/question/detail/xsdetail'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '问答-详情页-分发',
        path: '/quedetail',
        name: '/quedetail',
        components: {
          default: () => import('@@/question/detail/questiondetail'),
          header: Head,
          footer: Foot
        }
      },



      {
        title: '放映厅剧集支付',
        path: '/sectionpay',
        name: '/sectionpay',
        components: {
          default: () => import('@@/film/pay/pay'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '放映厅',
        path: '/filmlist',
        name: '/filmlist',
        components: {
          default: () => import('@@/film/list/list'),
          header: Head,
          footer: Foot
        }
      },
      {
        title: '放映厅详情页',
        path: '/filmdetail',
        name: '/filmdetail',
        components: {
          default: () => import('@@/film/detail/detail'),
          header: Head,
          footer: Foot
        }
      },

      {
        title: '打赏观看页',
        path: '/dsvideoshow',
        name: 'dsvideoshow',
        components: {
          default: () => import('@@/course/detail/dsvideoshow'),
          header: Head,
          footer: Foot
        }
      },


      {
        path: '/postfilmsectionpost/postfilmsection-v1',
        name: 'postfilmsection-v1',
        component: () => import('@@/newposter/filmsection-v1/filmsection-v1'),
        meta: {
          title: '点播海报'
        },
      },

      {
        path: '/create',
        redirect: '/create/works',
        components: {
          default: () => import('@@/create/create'),
          header: Head,
          footer: Foot
        },
        children: [
          {
            path: 'works',
            component: () => import('@@/create/works/works')
          },
          {
            path: 'column',
            component: () => import('@@/create/column/column')
          },
          {
            path: 'ques',
            component: () => import('@@/create/ques/ques')
          },
          {
            path: 'source',
            component: () => import('@@/create/source/source')
          },
        ]
      },
      {
        path: '/netpassport',
        components: {
          default: () => import('@@/netpassport/netpassport'),
          header: Head,
          footer: Foot
        },
      },
      {
        path: '/business',
        components: {
          default: () => import('@@/netpassport/business'),
          header: Head,
          footer: Foot
        },
      },
      {
        path: '/publication',
        components: {
          default: () => import('@@/netpassport/publication'),
          header: Head,
          footer: Foot
        },
      },
      {
        path: '/fsms',
        name: 'fsms',
        component: () => import('@@/sms/smsRedirect'),
        meta: {
          title: '短信中转页面'
        },
      },
      {
        path: '/ulinkfd',
        name: 'ulinkfd',
        component: () => import('@@/app/ulinkfilmdetail'),
        meta: {
          title: '分享ULINK中转页面'
        },
      },
      {
        path: '/linkapp',
        name: 'linkapp',
        component: () => import('@@/app/linkapp'),
        meta: {
          title: ''
        },
      },



      // 动画短片
      {
        path: '/nAnimatedVideo',
        name: 'nAnimatedVideo',
        components: {
          default: () => import('@@/news/nAnimatedVideo/nAnimatedVideo'),
          header: Head,
          footer: Foot
        }
      },
      {
        path: '/productionList',
        name: 'productionList',
        components: {
          default: () => import('@@/news/production/productionList'),
          header: Head,
          footer: Foot
        }
      },

      // 传统文化
      {
        path: '/nTradition',
        name: 'nTradition',
        components: {
          default: () => import('@@/news/nTradition/nTradition'),
          header: Head,
          footer: Foot
        }
      },
      // 故事汇列表页
      {
        path: '/storyList',
        name: 'storyList',
        components: {
          default: () => import('@@/news/story/storyList'),
          header: Head,
          footer: Foot
        }
      },
      // 动画制作
      {
        path: '/nAnimateMake',
        name: 'nAnimateMake',
        components: {
          default: () => import('@@/news/nAnimateMake/nAnimateMake'),
          header: Head,
          footer: Foot
        }
      },
      // 专栏列表页
      {
        path: '/ncolumnList',
        name: 'ncolumnList',
        components: {
          default: () => import('@@/news/ncolumn/ncolumnList'),
          header: Head,
          footer: Foot
        }
      },

      {
        path: '/appagreement',
        components: {
          default: () => import('@@/appagreement'),
          header: Head,
          footer: Foot
        }
      },

      {
        path: '/tea',
        components: {
          default: () => import('@@/tea'),
          header: Head,
          footer: Foot
        }
      },
      {
        path: '/tea/buy',
        components: {
          default: () => import('@@/tea/buy'),
          header: Head,
          footer: Foot
        }
      },

      // 数字人
      {
        path: '/meathuman',
        component: () => import("@@/meathuman")
      }

    ],

    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    }
  });
}
